import BWAccordion from 'components/shared/BWAccordion/index';
import FormEditorQuill from 'components/shared/BWFormControl/FormEditorQuill';
import React from 'react';

const JobApplicationProfileEn = ({ disabled, title, id }) => {
  return (
    <BWAccordion title={title} id={id}>
      <FormEditorQuill field='request_profile_en' disabled={disabled} />
    </BWAccordion>
  );
};

export default JobApplicationProfileEn;
